import _JSXStyle from "styled-jsx/style";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
export const TableHeaderCellAction = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClick,
    children,
    className,
    dataTest,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("button", _extends({}, props, {
    "data-test": dataTest,
    onClick: onClick,
    title: title,
    ref: ref,
    className: _JSXStyle.dynamic([["4225768774", [colors.grey400]]]) + " " + (className || "")
  }), children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4225768774",
    dynamic: [colors.grey400]
  }, ["button.__jsx-style-dynamic-selector{border:none;padding:0;background:transparent;width:24px;height:24px;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;cursor:pointer;border-radius:4px;margin-inline-start:2px;}", "button.__jsx-style-dynamic-selector:hover,button.__jsx-style-dynamic-selector:focus-visible{background:".concat(colors.grey400, ";}"), "button.__jsx-style-dynamic-selector:active,button.__jsx-style-dynamic-selector:focus{outline:none;}"]));
});
TableHeaderCellAction.displayName = 'TableHeaderCellAction';
TableHeaderCellAction.defaultProps = {
  dataTest: 'dhis2-uicore-tableheadercellaction'
};
TableHeaderCellAction.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func
};